import React, { useContext, useEffect, useMemo, useState } from 'react';
import {
  FormInput,
  MasterDetailForm,
  usePromise,
  Widget,
  FormDatePicker,
  Button,
  FormSwitch,
  FormSelect,
  Row,
  Col,
  ColumnProps,
  CrudContext,
} from '@digital/ui';
import { Collapse, Icon, Select, Table, Input, Switch, Tooltip } from 'antd';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  DadosGerais,
  deleteLinhaFile,
  downloadLinhaFile,
  getDadosGerais,
  getLinhasQaqc,
  LinhaQaqc,
  optionsNivelConformidade,
  optionsConformidade,
  updateLinhaQaqc,
  viewLinhaFile,
  usuarioLogadoAdmContratoControleQaqc,
  usuarioLogadoGestorContratoControleQaqc,
  updateNivelConformidade,
  updateConformidade,
  solicitarJustificativa,
  enviarJustificativa,
  concluirQaqc,
} from '@app/api/controleQaqc';
import UploadLinhaFile from './UploadLinhaFile';
import { GetFileExtension, imageFormats } from '@app/helpers';
import ModalJustificativas from './Justificativas/modalJustificativas';
import { hasPermission, hasPermissionPerfil } from '@app/helpers/permissions';
import './custom.css';
import { isObjNotEmpty } from '@app/helpers/objHelper';
import ModalJustificativaNaoAplicavel from './Justificativas/modalJustificativasNaoAplicavel';
import { isObjEmpty } from '@app/helpers/objHelper';
import { Visibility } from '@app/components';
import { usuarioLogadoState } from '@app/atoms';
import { useRecoilValue } from 'recoil';

interface Props {
  id: string;
  update: boolean;
  onUpdate: any;
}

const AbaControleQaqc = (props: Props) => {
  const { id, update, onUpdate } = props;
  const [linhasQaqc, setLinhasQaqc] = useState<LinhaQaqc[]>([]);
  const [ehTodasNa, setEhTodasNa] = useState(false);
  const [linhasClass, setLinhasClass] = useState({});
  const [dadosGerais, setDadosGerais] = useState<DadosGerais | null | undefined>(null);
  const [usuarioLogadoAdm, setUsuarioLogadoAdm] = useState(false);
  const [usuarioLogadoGestorMrn, setUsuarioLogadoGestorMrn] = useState(false);
  const [codStatus, setCodStatus] = useState(0);
  const usuarioLogado = useRecoilValue(usuarioLogadoState);

  const [somaPeso, setSomaPeso] = useState(0);
  const [hasPeso, setHasPeso] = useState(false);
  const [somaPesoValue, setSomaPesoValue] = useState(0);

  const { selectedItem } = useContext(CrudContext);

  const classesSelect = [
    'atende',
    'atendeParcialmente',
    'naoAtende',
    'vazio',
  ]

  const somaLinhas = (linhas: LinhaQaqc[], linhaUpdate = {} as LinhaQaqc) => {
    let soma = 0;
    let somaValores = 0;
    let naCount = 0;

    linhas.forEach((linha: LinhaQaqc) => {
      if (linha.pesoPergunta) {
        soma = soma + linha.pesoPergunta;
        if (linha.resultado.includes("true") || linha.resultado.includes("null")) {
          somaValores = somaValores + linha.pesoPergunta;
        }
      };

      if (linha.resultado.includes("null")) {
        naCount++;
      }

      if (isObjNotEmpty(linhaUpdate) && linhaUpdate.id === linha.id) {
        linha = linhaUpdate;
      }

    });

    if (soma >= 100) {
      setHasPeso(true);
      setSomaPeso(somaValores);
    };

    setEhTodasNa(linhas.length == naCount);

    setLinhasQaqc([...linhas]);
  }

  useMemo(() => {
    getDadosGerais(id).then(data => {
      if(data){
        setDadosGerais(data);
        setCodStatus(data.statusCodigo);
      }
    });
    getLinhasQaqc(id).then((data) => {
      if (data) {
        somaLinhas(data, undefined);
      }
    });
    usuarioLogadoAdmContratoControleQaqc(id).then(data => setUsuarioLogadoAdm(data));
    usuarioLogadoGestorContratoControleQaqc(id).then(data => setUsuarioLogadoGestorMrn(data));
  }, [id, update]);

  const handleUpdateLinhas = (values: LinhaQaqc) => {
    updateLinhaQaqc(values).then(data => {
      somaLinhas(linhasQaqc, values);
    });
  };

  useEffect(() => {
    let regra = somaPeso >= 85 ? 0 : somaPeso > 60 ? 1 : 2;
    regra = ehTodasNa && codStatus == 5 ? 3 : regra;

    setSomaPesoValue(regra);
  }, [somaPeso, codStatus, ehTodasNa]);

  const handleUpdateResumo = (values: LinhaQaqc) => {
    updateLinhaQaqc(values).then(data => {
      if (data.valid) {
        linhasQaqc.forEach(element => {
          if (values.id === element.id) element = values;
        });
        setLinhasQaqc([...linhasQaqc]);
        setLinhasClass({ ...linhasClass, [values.id]: '' });
      }
    });
  };

  const handleDeleteFile = (id: string) => {
    deleteLinhaFile(id).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  };

  const handleUpdateNivelConformidade = (e: string) => {
    updateNivelConformidade({ id, nivelConformidade: e }).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  };

  const handleUpdateConformidade = (e: number) => {
    updateConformidade({ id, conformidade: e }).then(data => {
      if (data.valid) {
        onUpdate();
      }
    });
  };

  const handleSolicitarJustificativa = () => {
    solicitarJustificativa(id).then(data => {
      hasPeso ? updateNivelConformidade({ id, nivelConformidade: optionsNivelConformidade[somaPesoValue].value }).then(data => {
        if (data.valid) {
          onUpdate();
        }
      }) : onUpdate();;
    });
  };

  const handleEnviarJustificativa = () => {
    enviarJustificativa(id).then(data => onUpdate());
  };

  const handleConcluirQaqc = () => {
    concluirQaqc(id).then(data => {
      hasPeso ? updateNivelConformidade({ id, nivelConformidade: optionsNivelConformidade[somaPesoValue].value }).then(data => {
        if (data.valid) {
          onUpdate();
        }
      }) : onUpdate();;
    });
  };

  const columns: ColumnProps<LinhaQaqc>[] = [
    {
      title: 'Item',
      dataIndex: 'item',
      width: '1%',
    },
    {
      title: 'Atividade',
      dataIndex: 'atividade',
      width: '35%',
    },
    {
      title: 'Peso',
      dataIndex: 'pesoPergunta',
      width: '1%',
      align: 'center',
      render: (text, record, index) => {
        if (record.pesoPergunta != 0) {
          return record.pesoPergunta;
        } else {
          return "N/A";
        }
      }
    },
    {
      title: 'Resultado',
      dataIndex: 'resultado',
      width: '5%',
      render: (text, record, index) => {
        record.resultado = record.resultado ? record.resultado.toString() : 'null';
        return (
          <Select
            defaultValue={record.resultado}
            onChange={e => {
              record.resultado = e;
              handleUpdateLinhas(record);
            }}
            disabled={!usuarioLogadoAdm || [2, 4, 5].includes(codStatus)}>
            <Select.Option value={'true'}>Sim</Select.Option>
            <Select.Option value={'false'}>Não</Select.Option>
            <Select.Option value={'null'}>N/A</Select.Option>
          </Select>
        );
      },
    },
    {
      title: 'AÇÃO A SER ADOTADA',
      dataIndex: 'acao',
      width: '20%',
      render: (text, record, index) => {
        if (record.resultado === 'false') {
          return record.acao;
        } else {
          return 'Nenhuma Ação';
        }
      },
    },
    {
      title: 'RESUMO DA NÃO CONFORMIDADE',
      dataIndex: 'resumoNaoConformidade',
      render: (text, record) => {
        let current = record.resumoNaoConformidade;
        return (
          <Tooltip
            title={record.resumoNaoConformidade}
          >
            <Input
              className={linhasClass[record.id]}
              defaultValue={record.resumoNaoConformidade}
              onPressEnter={e => {
                record.resumoNaoConformidade = e.target.value;
                handleUpdateResumo(record);
              }}
              onChange={e => {
                if (current !== e.target.value) {
                  setLinhasClass({ ...linhasClass, [record.id]: 'not-saved' });
                } else {
                  setLinhasClass({ ...linhasClass, [record.id]: '' });
                }
              }}
              disabled={!usuarioLogadoAdm || [2, 4, 5].includes(codStatus)}
            />
          </Tooltip>
        );
      },
    },
    {
      title: 'Justificativa Gestor?',
      width: '5%',
      render: (text, record) => {
        return (
          <>
            <ModalJustificativas linhaId={record.id} contemComentario={record.contemJustificativa} />
            <Visibility visible={
              [2].includes(codStatus)
            }>
              <Visibility 
                visible={
                  (usuarioLogadoAdm || (dadosGerais ? usuarioLogado.id == dadosGerais.usuarioGestorId : false))
                }
              >
                <UploadLinhaFile
                  onUpdate={onUpdate}
                  linhaId={record.id}
                  arquivoId={record.arquivos.length > 0 ? record.arquivos[0].id : null}
                  hasFile={record.arquivos.length > 0}
                />
                <Visibility 
                  visible={
                    record.arquivos.length > 0
                  }
                >
                  <Tooltip title="Deletar Arquivo">
                    <Button
                      icon="science-minus"
                      type="link"
                      onClick={() => {
                        handleDeleteFile(record.arquivos[0].id);
                      }}
                    />
                  </Tooltip>
                </Visibility>
              </Visibility>
            </Visibility>
            <Visibility 
              visible={
                record.arquivos.length > 0
              }
            >
              <Tooltip title="Download Arquivo">
                  <Button
                    icon="ui-download"
                    type="link"
                    onClick={() => {
                      downloadLinhaFile(record.arquivos[0].id, record.arquivos[0].nome);
                    }}
                  />
                </Tooltip>
                <Visibility visible={
                  record.arquivos.length > 0 && (GetFileExtension(record.arquivos[0].nome) === 'pdf' ||
                  imageFormats.includes(GetFileExtension(record.arquivos[0].nome)))
                }>
                  <Tooltip title="Visualizar Arquivo">
                    <Button
                      icon="files-view_file"
                      type="link"
                      onClick={() => {
                        viewLinhaFile(record.arquivos[0].id, record.arquivos[0].nome);
                      }}
                    />
                  </Tooltip>
                </Visibility>
            </Visibility>
            <Switch
              checked={record.justificativa}
              onChange={e => {
                record.justificativa = e;
                handleUpdateLinhas(record);
              }}
              disabled={!usuarioLogadoAdm || [2, 4, 5].includes(codStatus)}
            />
          </>
        );
      },
    },
  ];

  const { Panel } = Collapse;
  return (
    <>
      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="dadosGeraisControle" header={<span>Dados Gerais do Controle</span>} style={{ border: 0 }}>
          <MasterDetailForm initialValues={dadosGerais}>
            <Widget>
              <Visibility
                visible={!!selectedItem.isMultiplosGestores}
              >
                <Row>
                  <FormInput label="PQ" name="pq" span={2} disabled />
                  <FormInput label="Escopo" name="escopo" span={2} disabled />
                </Row>
              </Visibility>
              <Row>
                <FormInput label="Status" name="statusNome" span={4} disabled />
                <FormInput label="Contrato" name="numeroContrato" span={2} disabled />
                <FormInput label="BM" name="numeroBm" span={2} disabled />
                <FormDatePicker
                  label="Período Medição Inicial"
                  name="periodoInicio"
                  span={2}
                  format="DD/MM/YYYY"
                  disabled
                />
                <FormDatePicker label="Período Medição Final" name="periodoFim" span={2} format="DD/MM/YYYY" disabled />
                <FormInput
                  label="Administrador contrato responsável pela análise"
                  name="administrador"
                  span={4}
                  disabled
                />
                <FormDatePicker span={4} label="Data conclusão" name="dataConclusao" format="DD/MM/YYYY" disabled />
                {hasPermission(['MEDICAO_CONTROLE_QAQC_NIVEL_CONFORMIDADE']) ? (
                  <FormInput span={4} label="Modo geração" name="modoGeracao" disabled />
                ) : (
                  <></>
                )}
                {hasPermission(['MEDICAO_CONTROLE_QAQC_NIVEL_CONFORMIDADE']) ? (
                  <FormInput label="Justificativa Não Aplicável" name="justificativaNaoAplicavel" span={4} disabled />
                ) : (
                  <></>
                )}
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
      <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />}>
        <Panel key="checklist" header={<span>Dados Gerais do Controle</span>} style={{ border: 0 }}>
          {dadosGerais !== null ? (
            <MasterDetailForm initialValues={dadosGerais}>
              <Widget
                actions={[
                  ((usuarioLogadoGestorMrn || hasPermission(['SGC_APROVAR_JUSTIFICATIVA_CONTROLE_QUALIDADE'])) && codStatus === 2) ? (
                    <Button type="link" icon="arrows-left2" onClick={e => handleEnviarJustificativa()}>
                      Enviar Justificativa
                    </Button>
                  ) : (
                    <> </>
                  ),
                  linhasQaqc.length > 0 &&
                    linhasQaqc.filter(e => e.justificativa === true).length > 0 &&
                    (codStatus === 1 || codStatus === 3) &&
                    usuarioLogadoAdm ? (
                    <Button type="link" icon="commons-share_3" onClick={e => handleSolicitarJustificativa()}>
                      Solicitar Justificativa
                    </Button>
                  ) : (
                    <></>
                  ),
                  usuarioLogadoAdm && [1, 3].includes(codStatus)
                    && ehTodasNa && isObjEmpty(dadosGerais.justificativaNaoAplicavel) ? (
                    <ModalJustificativaNaoAplicavel
                      controleQaQcId={id}
                      reload={onUpdate}
                    />
                  ) : (
                    <></>
                  ),
                  usuarioLogadoAdm && (codStatus === 1 || codStatus === 3) ? (
                    <Button icon="ui-approval" onClick={e => handleConcluirQaqc()}>
                      concluir
                    </Button>
                  ) : (
                    <></>
                  ),
                ]}>
                <PerfectScrollbar>
                  {linhasQaqc ? (
                    <Table columns={columns} dataSource={linhasQaqc} rowKey={'id'} pagination={false} />
                  ) : (
                    <></>
                  )}
                  <Row>
                    <hr />
                    <br />
                  </Row>
                  <Row>
                    {hasPeso ? (
                      <Row style={{ display: 'flex' }}>
                        <Col span={4}>
                          <FormSelect
                            span={12}
                            options={optionsNivelConformidade}
                            value={optionsNivelConformidade[
                              somaPesoValue
                            ].value}
                            label="Nível de Conformidade"
                            name="nivelConformidade"
                            onChange={e => handleUpdateNivelConformidade(e)}
                            disabled={true}
                            className={classesSelect[somaPesoValue]}
                          />
                        </Col>
                        <Col>
                          <Row>
                            <span>Total</span>
                          </Row>
                          <Row>
                            <input type="text"
                              value={ehTodasNa && codStatus == 5 ? '' : somaPeso}
                              className={'inputSoma'}
                              disabled />
                          </Row>
                        </Col>
                      </Row>
                    ) : (
                      <>
                        {hasPermission(['MEDICAO_CONTROLE_QAQC_NIVEL_CONFORMIDADE']) ? (
                          <Col span={4}>
                            <FormSelect
                              span={12}
                              options={optionsNivelConformidade}
                              label="Nível de Conformidade"
                              name="nivelConformidade"
                              onChange={e => handleUpdateNivelConformidade(e)}
                                disabled={!usuarioLogadoAdm || [4, 5].includes(codStatus)}
                            />
                          </Col>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                  </Row>
                </PerfectScrollbar>
              </Widget>
            </MasterDetailForm>
          ) : (
            <></>
          )}
        </Panel>
      </Collapse>
    </>
  );
};

export default AbaControleQaqc;
